export const LEGEND_COLORS = {
  signups: "bg-green-40",
  jobs_completed: "bg-green-30",
} as const;
